<template>
  <div class="client-bids min-vh-100">
    <div class="container-fluid client">
      <div class="clientWrap">
        <div class="row">
          <div class="col-md-12 py-4 text-left">
            <div class="d-flex justify-content-between align-items-center">
              <h1>Notifications</h1>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="dark-filter w-100 p-1 mb-2 d-inline-block">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="ml-3 m-0">Filters</h5>
                <span class="btn btn-link" @click="showFilters = !showFilters">
                  <i
                    class="fa"
                    v-bind:class="[
                      showFilters ? 'fa-angle-up' : 'fa-angle-down'
                    ]"
                  ></i>
                  {{ showFilters ? 'Hide' : 'Show' }} Filters
                </span>
              </div>
              <div class="row p-4" v-if="showFilters">
                <div class="col-lg-12">
                  <form class="row">
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">From</label>
                      <datepicker
                        v-model="fromDate"
                        name="fromDate"
                        placeholder="mm/dd/yyyy" 
                        format="MM/dd/yyyy"
                        :clear-button="true"
                        :calendar-button="true"
                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"
                      ></datepicker>
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">To</label>
                      <datepicker
                        v-model="toDate"
                        name="toDate"
                        placeholder="mm/dd/yyyy" 
                        format="MM/dd/yyyy"
                        :clear-button="true"
                        :calendar-button="true"
                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"
                      ></datepicker>
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">User</label>
                      <multiselect
                        v-model="selectedClient"
                        placeholder="Select"
                        :options="clients"
                        :multiple="false"
                        label="firstName"
                        track-by="id"
                      ></multiselect>
                      <!-- <select class="form-control" v-model="searchTerm">
                        <option value="" disabled selected>Select User</option>
                        <option v-for="client in clients" :key="client.firstName" :value="client.firstName + ' ' + client.lastName">
                          {{ client.firstName }} {{ client.lastName }}
                        </option>
                      </select> -->

                      <!-- <input type="text" class="form-control" placeholder="Search by Client Name" v-model="searchTerm"> -->
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">Alert Type</label>
                      <select
                        v-model="alertType"
                        class="form-control"
                        style="height: 40px"
                      >
                        <option value="">SELECT</option>
                        <option value="EMAIL">EMAIL</option>
                        <option value="PUSH_NOTIFICATION">
                          PUSH NOTIFICATION
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6 col-lg-3">
                      <button
                        @click="clearFilter()"
                        type="button"
                        class="btn btn-secondary rounded mt-4"
                      >
                        Clear
                      </button>
                      <button
                        @click="searchLog()"
                        type="button"
                        class="btn btn-primary rounded mt-4"
                      >
                        Filter
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="history filter-list">
              <div class="table-responsive p-0">
                <div class="loader" v-if="loading"></div>

                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th 
                      scope="col" 
                      class="sort text-left" 
                      v-if="isAdmin || isRep"
                      v-bind:class="[
                        sortOrder == 'ASC' 
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' 
                          ? 'sort-client-desc'
                          : '',
                        ]"
                        @click="sort()"
                      >
                        User
                      </th>
                      <th scope="col" class="text-left">Alert Type</th>
                      <th scope="col" class="text-left">Date</th>
                      <th scope="col" class="text-left">Message</th>
                    </tr>
                  </thead>
                  <tbody class="list no-cursor">
                    <tr v-if="logs.length == 0 && !loading">
                      <td>
                        <p class="nodata text-white">No data available</p>
                      </td>
                    </tr>
                    <tr v-for="data in logs" :key="data.id">
                      <td v-if="isAdmin || isRep" class="text-left">{{ data.userName }}</td>
                      <td class="text-left">{{data.alertType}}</td>
                      <td class="text-left">
                        {{
                          data.createdDate
                            ? moment(data.createdDate).format(
                                'MMMM DD YYYY, h:mm:ss a'
                              )
                            : ''
                        }}
                      </td>
                      <td class="text-left">{{ data.msg }}</td>
                    </tr>
                  </tbody>
                </table>
                <nav
                  aria-label="Page navigation example"
                  v-if="!(logs.length == 0 && currentPage === 0)"
                >
                  <ul class="pagination justify-content-center">
                    <li
                      class="page-item"
                      v-bind:class="{ disabled: currentPage === 0 }"
                    >
                      <a class="page-link cursor-pointer" @click="previous()">
                        <i class="fa fa-angle-left"></i>
                        <span class="sr-only">Previous</span>
                      </a>
                    </li>
                    <li class="page-item active">
                      <a class="page-link">{{ currentPage + 1 }}</a>
                    </li>
                    <li
                      class="page-item"
                      v-bind:class="{
                        disabled: this.logs.length < this.perPage
                      }"
                    >
                      <a class="page-link cursor-pointer" @click="next()">
                        <i class="fa fa-angle-right"></i>
                        <span class="sr-only">Next</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import authService from '@/authService'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'imsCusipComponent',
  components: {
    Datepicker
  },
  data () {
    return {
      accessToken: null,
      loading: false,
      currentPage: 0,
      perPage: 25,
      searchValue: '',
      totalRows: 0,
      sortColumn: '',
      sortOrder: 'ASC',
      logs: [],
      moduleName: '',
      showFilters: false,
      alertType: '',
      fromDate: '',
      toDate: '',
      isAdmin: false,
      isRep: false,
      clients: [],
      searchTerm: '',
      selectedClient: null
    }
  },
  methods: {
    getClients () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let url =
        config.baseUrlBidSide +
        '/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Client'

      this.$http
        .get(url, auth)
        .then(result => {
          this.clients = result.data.content
        })
        .catch(e => {
          console.log(e)
        })
    },
    sort () {
      this.sortOrder =
        this.sortOrder == 'ASC'
          ? (this.sortOrder = 'DESC')
          : (this.sortOrder = 'ASC')
      this.feedAlerts()
    },
    clearFilter () {
      this.alertType = ''
      this.fromDate = ''
      this.toDate = ''
      this.currentPage = 0
      this.searchTerm = ''
      this.selectedClient = null
      this.feedAlerts()
    },
    searchLog () {
      this.currentPage = 0
      this.feedAlerts()
    },
    next () {
      if (this.logs.length === this.perPage) {
        this.currentPage++
        this.feedAlerts()
      }
    },
    previous () {
      if (this.currentPage > 0) {
        this.currentPage--
        this.feedAlerts()
      }
    },
    feedAlerts () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      var fDate = this.fromDate
        ? this.moment(this.fromDate).utc().format('YYYY-MM-DD')
        : ''
      var tDate = this.toDate
        ? this.moment(this.toDate).utc().format('YYYY-MM-DD')
        : ''
      var clientRepId = ''
      if (this.isRep && !this.isAdmin) {
        clientRepId = authService.getUser().id
      }
      if (this.selectedClient) {
        this.searchTerm =
          this.selectedClient.firstName + ' ' + this.selectedClient.lastName
      } else {
        this.searchTerm = ''
      }
      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/offering-feed/alerts?alertType=' +
            this.alertType +
            '&offset=' +
            this.currentPage +
            '&limit=' +
            this.perPage +
            '&cognitoSub=' +
            authService.getUser().cognitoSub +
            '&fromDate=' +
            fDate +
            '&toDate=' +
            tDate +
            '&isForClient=true' +
            '&clientRepId=' +
            clientRepId +
            '&sortByName=true' +
            '&sortOrder=' +
            this.sortOrder +
            '&search=' +
            this.searchTerm,

          auth
        )
        .then(result => {
          this.logs = result.data
          this.loading = false
        })
        .catch(e => {
          console.log(e)
          this.loading = false
        })
    }
  },
  mounted () {
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log('accessToken is not found', err)
      } else {
        this.tenantName = role[0].split('-')[0]
        var roleArray = role.map(item => {
          return item.split('-')[1]
        })
        roleArray.includes('Admin')
          ? (this.isAdmin = true)
          : (this.isAdmin = false)
        roleArray.includes('Rep') ? (this.isRep = true) : (this.isRep = false)
        this.feedAlerts()
        this.getClients()
      }
    })
  }
}
</script>
<style scoped>
.loader {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4c6fff; /* soft neon blue */
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin: auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
